import { User } from "./Interfaces";

// api keys
export const MAPS_API_KEY = "AIzaSyCThB6eQuGL8_qUbDXIFykwo6NQklP81kw"; // REMOVED

// app links
export const URL_IOS_APP = "https://apps.apple.com/gb/app/safe-car-wash/id1391799915";
export const URL_ANDROID_APP = "https://play.google.com/store/apps/details?id=com.kore.safecarwash&hl=en_GB&gl=US";

// api endpoints/urls
//export const API_BASE_URL = "https://scw.aimernginx.co.uk/scw/admin";
//export const API_BASE_URL = "https://tci-middleware.development.pocketappserver.net/scw/admin";
export const API_BASE_URL = "https://api-middleware.tci-safecarwashapp.co.uk/scw/admin";
export const API_ENDPOINT_GET_REPORTS = "/getReports";
export const API_ENDPOINT_GET_USERS = "/getUsers";
export const API_ENDPOINT_CREATE_USER = "/createAUser";
export const API_ENDPOINT_EDIT_USER = "/editAUser";
export const API_ENDPOINT_DELETE_USER = "/deleteAUser";
export const API_ENDPOINT_VERIFY_USER = "/verifyUser";
export const API_ENDPOINT_PASSWORD_RESET = "/passwordReset";
export const API_ENDPOINT_PASSWORD_UPDATE = "/emailpassreset";
export const API_ENDPOINT_GET_GROUPS = "/getGroups";
export const API_ENDPOINT_DELETE_GROUP = "/deleteGroup";
export const API_ENDPOINT_CREATE_GROUP = "/createGroup";
export const API_ENDPOINT_EDIT_GROUP = "/editGroup";
export const API_ENDPOINT_AIRTABLE = "https://api.airtable.com";
export const API_KEY_AIRTABLE = ""; // REMOVED
export const API_BASE_ID_AIRTABLE = ""; // REMOVED
export const API_FAQS_TABLE_NAME_AIRTABLE = "FAQs (Admin Site)";

// local storage keys
export const STORAGE_KEY_AIMER_USER_ID = "AIMER_USER_ID";
export const STORAGE_KEY_FB_USER_ID = "FB_USER_ID";
export const STORAGE_KEY_JWT = "JWT";

// default types
export const DEFAULT_USER: User = {
  id: "0",
  fbId: "",
  email: "",
  displayName: "",
  groups: "",
  area: "",
  weeklyReports: 0,
};
